/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useLayoutEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {STATUSES} from '../routes/EasyOnboard/FraudCheckScreens';
import {setFraudRules, setWidgetScreen} from '../store/actions';

export const useFraudCheck = () => {
  const dispatch = useDispatch();
  const [selectedMatchScore, setSelectedMatchScore] = useState(50);
  const [selectedCategory, setSelectedCategory] = useState(['pep', 'warning']);
  const [selectedStatus, setSelectedStatus] = useState();
  const [config, setConfig] = useState(null);
  const {fraudRules, widgetScreen} = useSelector(state => state.widgets);

  const foundRule = useMemo(
    () => fraudRules.find(rule => rule?.page === widgetScreen?.page),
    [fraudRules, widgetScreen],
  );

  useEffect(() => {
    if (foundRule) {
      dispatch(setWidgetScreen(foundRule));
      setConfig(foundRule[foundRule?.page]);
    }
  }, [fraudRules?.length]);

  useEffect(() => {
    if (fraudRules?.length) {
      const updatedRules = fraudRules?.map(rule => {
        if (rule.page === widgetScreen?.page) {
          return {
            ...rule,
            [rule.page]: config || foundRule[foundRule?.page],
          };
        }
        return rule;
      });

      dispatch(setFraudRules(updatedRules));
    }

    setSelectedStatus(STATUSES[0]);
    setSelectedCategory(
      Array.isArray(config?.category) ? config?.category : ['pep', 'warning'],
    );
  }, [config, STATUSES, setSelectedStatus]);

  return {
    setSelectedStatus,
    setSelectedMatchScore,
    selectedMatchScore,
    setSelectedCategory,
    selectedStatus,
    selectedCategory,
    setConfig,
    config,
    STATUSES,
  };
};

export const usePersistFraudData = ({
  COLLECTION,
  config,
  selectedStatus,
  actionKey,
}) => {
  const [data, setData] = useState();

  useLayoutEffect(() => {
    const actionValue = config?.[actionKey]?.toString();
    if (Array.isArray(COLLECTION)) {
      const action = COLLECTION.find(status => status.value === actionValue);
      if (action === undefined) {
        setData(selectedStatus);
      } else {
        setData(action);
      }
    } else {
      setData(actionValue);
    }
  }, [config?.[actionKey], selectedStatus]);

  return data;
};
